import angular from 'angular';
import template from './mobile-patient-actions.html';
class OneToOneMobilePatientActionsController {
    constructor() { }
    $onInit() { }
}
const oneToOneMobilePatientActions = {
    template,
    bindings: {
        onToggleAudio: '&',
        hasAudio: '&',
        activeVideoProvider: '<',
    },
    controller: OneToOneMobilePatientActionsController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrame.selfVideoFrameFull.actions.oneToOne.mobilePatientActions', [])
    // one-to-one-mobile-patient-actions
    .component('oneToOneMobilePatientActions', oneToOneMobilePatientActions).name;
